/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Injectable } from '@angular/core';
import {
  BuilderFormSchemaFactory,
  FormRootSchema,
  FormState,
  FormStateSchema,
} from '@gh/builder-shared';
import { ContactTermsPayables } from '@gh/builder-shared-data';
import { NumberTypes, toAppFormGroup, updateChildrenSchema } from '@gh/common-shared';
import { getControlValue } from '@gh/core-ui';
import {
  ContactTermsPayee,
  isTermsPayablesAllowDays,
  isTermsPayablesBalanceAsDayOfMonth,
  isTermsPayablesDueDateRequired,
} from '../../resources/model/contact-shared.model';

const getTermsPayeeSchema = (payment: ContactTermsPayee) => {
  const isDueDaysRequired = isTermsPayablesDueDateRequired(payment.paymentIsDue);
  const isDueDateOfMonth = isTermsPayablesBalanceAsDayOfMonth(payment.paymentIsDue);
  const allowDays = isTermsPayablesAllowDays(payment.paymentIsDue);

  return {
    paymentIsDue: { required: true },
    dueDays: {
      required: isDueDaysRequired,
      enabled: allowDays,
      type: isDueDateOfMonth ? NumberTypes.DayOfMonth : NumberTypes.Days,
    },
    discountDays: { enabled: allowDays, type: NumberTypes.Days },
    discountPct: { enabled: allowDays, type: NumberTypes.Percents_2 },
  };
};

@Injectable()
export class ContactDetailsSharedTermsPayeeFormStateFactory {
  constructor(private schemaFactory: BuilderFormSchemaFactory) {

  }

  create(): ContactDetailsSharedTermsPayeeFormState {
    return new ContactDetailsSharedTermsPayeeFormState(this.schemaFactory);
  }
}

export class ContactDetailsSharedTermsPayeeFormState extends FormState<ContactTermsPayee> {
  constructor(private schemaFactory: BuilderFormSchemaFactory) {
    super(schemaFactory);
  }

  get paymentIsDue(): ContactTermsPayables {
    return getControlValue(this.group, 'paymentIsDue');
  }

  update(): void {
    updateChildrenSchema(toAppFormGroup(this.group), getTermsPayeeSchema(this.group.value));
  }

  protected buildSchema(terms: ContactTermsPayee, { root }: FormStateSchema): FormRootSchema {
    return root({
      children: getTermsPayeeSchema(terms),
    });
  }
}
